import React from 'react';
import { useNavigate } from 'react-router-dom';
import ToDoList from './ToDoList';

/**
 * MasterToDoList — the /master-todo page. Just a page shell around the ONE rich
 * ToDoList in master mode, so it is identical to the popup and dashboard panel.
 */
export default function MasterToDoList() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen p-6" style={{ background: 'linear-gradient(135deg, rgba(20,20,30,0.98) 0%, rgba(30,30,40,0.95) 100%)' }}>
      <div className="mx-auto max-w-5xl">
        <div className="mb-6 flex items-center gap-4">
          <button onClick={() => navigate(-1)} data-testid="master-todo-back" className="text-2xl text-[#D4A574] hover:text-white">←</button>
          <h1 className="text-3xl font-bold text-[#D4A574]">Master To-Do List</h1>
        </div>
        <ToDoList masterMode />
      </div>
    </div>
  );
}
